/**
 * Names of all script functions.
 *
 * @module
 */

/** Script function type for `0x1::resource_account::create_resource_account`. */
export const create_resource_account =
  "0x1::resource_account::create_resource_account" as const;
